import { SlidersHorizontal } from 'lucide-react';
import { CLAIM_MODE_META, type ClaimMode } from '@/store/claim-mode-store.js';

// Shows which R&D-value method a figure was computed with. Use the `mode` returned by the API
// (not the global toggle) so a LOCKED claim correctly shows its frozen lock-time method.
export function ClaimModeBadge({ mode, locked }: { mode?: string | null; locked?: boolean }) {
  if (!mode || !(mode in CLAIM_MODE_META)) return null;
  const meta = CLAIM_MODE_META[mode as ClaimMode];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs text-muted-foreground"
      title={meta.description}
    >
      <SlidersHorizontal className="h-3 w-3" aria-hidden="true" />
      {meta.label}{locked ? ' · locked' : ''}
    </span>
  );
}
